var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterItem"},[(_vm.label)?_c('span',{staticClass:"filterItem_label",style:({
      marginRight: (_vm.spacing + "px")
    })},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }